module.exports = __webpack_public_path__ + "img/Raiva_Corpo_1.18ca6c3b.png";